import React, { useRef, useEffect } from 'react';
import { ListingModal } from './Modal';
import { withConfig } from './config';
import { ContextHolder } from './ContextHolder';

let uuid = 0;
const destroyFns = [];

export const useListingModal = () => {
  const holderRef = useRef(null);
  const [actionQueue, setActionQueue] = React.useState([]);

  useEffect(() => {
    if (actionQueue.length) {
      const cloneQueue = [...actionQueue];

      cloneQueue.forEach((action) => {
        action();
      });

      setActionQueue([]);
    }
  }, [actionQueue]);

  const getShowFunc = React.useCallback((withConfig) => {
    return function hookShow(props) {
      const modalRef = React.createRef(null);
      uuid += 1;
      let silent = false;
      let resolvePromise = null;
      let closeFunc;

      const promise = new Promise((resolve) => {
        resolvePromise = resolve;
      });

      const modal = (
        <ListingModal
          key={`listing-modal-${uuid}`}
          config={withConfig(props)}
          ref={modalRef}
          afterClose={() => {
            closeFunc?.();
          }}
        />
      );

      closeFunc = holderRef.current?.patchElement(modal);

      if (closeFunc) {
        destroyFns.push(closeFunc);
      }

      const instance = {
        destroy: () => {
          function destroyAction() {
            modalRef.current?.destroy();
          }

          if (modalRef.current) {
            destroyAction();
          } else {
            setActionQueue((prev) => [...prev, destroyAction]);
          }
        },
        update: (newConfig) => {
          function updateAction() {
            modalRef.current?.update(newConfig);
          }

          if (modalRef.current) {
            updateAction();
          } else {
            setActionQueue((prev) => [...prev, updateAction]);
          }
        },
        then: (resolve) => {
          silent = true;
          return promise.then(resolve);
        },
      };

      return instance;
    };
  }, []);

  const showFunc = React.useMemo(() => {
    return {
      show: getShowFunc(withConfig),
    };
  }, []);

  return [showFunc, <ContextHolder key="modal-holder" ref={holderRef} />];
};
